const TOKEN_KEY = 'auth_tokens';

export const tokenService = {
  setTokens(tokens) {
    const { access_token, refresh_token, expires_in } = tokens;
    const expiresAt = new Date().getTime() + expires_in * 1000;
    
    const tokenData = {
      access_token,
      refresh_token,
      expires_at: expiresAt,
    };
    
    localStorage.setItem(TOKEN_KEY, JSON.stringify(tokenData));
  },

  getTokens() {
    const tokenData = localStorage.getItem(TOKEN_KEY);
    return tokenData ? JSON.parse(tokenData) : null;
  },

  clearTokens() {
    localStorage.removeItem(TOKEN_KEY);
  },

  isTokenExpired() {
    const tokenData = this.getTokens();
    if (!tokenData) return true;
    
    // Agregamos un margen de 1 minuto antes de la expiración real
    const expirationMargin = 60 * 1000; 
    return new Date().getTime() >= (tokenData.expires_at - expirationMargin);
  },

  getAccessToken() {
    const tokenData = this.getTokens();
    return tokenData ? tokenData.access_token : null;
  },

  getRefreshToken() {
    const tokenData = this.getTokens();
    return tokenData ? tokenData.refresh_token : null;
  },

  setUserId(userId) {
    localStorage.setItem('user_id', userId);
  },

  getUserId() {
    return localStorage.getItem('user_id');
  },
};
